import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Header.css';
import './PhoneVerificationBanner.css';

const Header = ({ pageTitle, forceUnauthenticated = false }) => {
  const navigate = useNavigate();
  const { logout, user } = useAuth();
  const [isBannerVisible, setIsBannerVisible] = useState(true);
  
  // Если forceUnauthenticated = true или аккаунт не подтвержден — показываем хедер как для неавторизованного пользователя
  const displayUser = forceUnauthenticated || (user && !user.is_verified) ? null : user;

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleCloseBanner = () => {
    setIsBannerVisible(false);
  };

  return (
    <>
      <header className="app-header">
        <div className="header-left">
          <img 
            src="/rose.png" 
            alt="RoseLearn" 
            className="header-logo"
            onClick={() => navigate('/')}
            style={{ cursor: 'pointer' }}
          />
          <h1 
            className="header-title"
            onClick={() => navigate('/')}
            style={{ cursor: 'pointer' }}
          >
            <span className="title-rose">Rose</span>Learn.me
          </h1>
        </div>
        <div className="header-right">
          {displayUser ? (
            <>
              <span 
                className="header-link" 
                onClick={() => navigate('/dashboard')}
              >
                Личный кабинет
              </span>
              <span 
                className="header-link" 
                onClick={() => navigate('/settings')}
              >
                Настройки
              </span>
              <span 
                className="header-link header-link-logout" 
                onClick={handleLogout}
              >
                Выход
              </span>
            </>
          ) : (
            <>
              <span 
                className="header-link" 
                onClick={() => navigate('/login')}
              >
                Вход
              </span>
              <span 
                className="header-link" 
                onClick={() => navigate('/register/student')}
              >
                Регистрация
              </span>
            </>
          )}
        </div>
      </header>
      <hr className="header-bottom-divider" />
      {displayUser && !displayUser.is_phone_verified && window.location.pathname !== '/verify-email' && isBannerVisible && (
        <div className="phone-verification-banner">
          <div className="banner-content">
            <span className="banner-text">Подтвердите номер телефона в настройках для полного доступа к функциям</span>
            <button 
              className="banner-button"
              onClick={() => navigate('/settings?section=security')}
            >
              Перейти в настройки
            </button>
          </div>
          <button 
            className="banner-close"
            onClick={handleCloseBanner}
            title="Закрыть"
          >
            ×
          </button>
        </div>
      )}
    </>
  );
};

export default Header;

